import { createContext, useContext, useMemo, useReducer } from 'react';
import { appUsersHandlers, appUsersReducer, appUsersReducerInitialState } from '../reducers/AppUsersReducer';
import { AppContext } from './AppProvider';
import { DatabaseContext } from './DatabaseContext';
import { PapsContext } from './PapsContext';
import { useRenders } from './useHelpers/useRenders';

/** 
@provides appUser_state
@provides appUser_handlers 
*/
export const AppUsersContext = createContext();

const AppUsersProvider = (props) => {

  // parentContext not available  

  const appContext = useContext(AppContext)
  const { app_state } = appContext ?? {}
  const { mainStorage } = app_state ?? {}

  const databaseContext = useContext(DatabaseContext)
  const { database_fns } = databaseContext ?? {}

  // papsContext
  const papsContext = useContext(PapsContext)
  const { paps_state } = papsContext ?? {}
  const { pathViews } = paps_state ?? {}

  useRenders('AppUsersProvider', true)

  // local state
  const initState = appUsersReducerInitialState({ database_fns, pathViews, mainStorage })
  const [appUsers_state, appUsers_dispatch] = useReducer(appUsersReducer, initState);

  const appUsers_handlers = useMemo(
    () => appUsersHandlers(appUsers_dispatch),
    [appUsers_dispatch]
  );

  const provider = () => {
    return <AppUsersContext.Provider value={{
      appUsers_state,
      appUsers_handlers,
    }} >
      {props.children}
    </AppUsersContext.Provider >
  }

  return provider()
}

export default AppUsersProvider